import { makeAutoObservable } from 'mobx';

export type ExercisePositionPrimary = 'standing' | 'sitting' | 'kneeling' | 'cross_legged';
export type ExercisePositionSecondary =
  | 'straight'
  | 'inclined_front'
  | 'inclined_back'
  | 'inclined_side'
  | 'back'
  | 'belly'
  | 'side';

// Raw JSON from backend
export type ExercisePositionJson = {
  primary: ExercisePositionPrimary;
  secondary?: ExercisePositionSecondary;
};

// Observable model type (same as JSON - no transformation needed)
export type ExercisePosition = ExercisePositionJson;

// Factory function
export function createExercisePosition(json?: Partial<ExercisePositionJson>): ExercisePosition {
  return makeAutoObservable({
    primary: json?.primary ?? 'standing',
    secondary: json?.secondary,
  });
}
